import React from 'react'
import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import DescBanner from '../shared/DescBanner'
import Footer from '../Footer/footer'
import MaterialTailwindCard from '../shared/Card'
import img1 from '../assets/images/services/Concept development.webp'
import img2 from '../assets/images/services/Space optimization.webp'
import img3 from '../assets/images/services/site analysis.webp'
import img4 from '../assets/images/Projekt_2/P_2201_02.jpg'

export default function Planning() {
  return (
    <div>
      <Navbar/>
      <TittleBanner img="bg-about-us-banner" tiitle="Planning"/>
      <DescBanner text="At Arcium Studio, every great project begins with thoughtful, detailed planning. Our architectural planning service is the foundation of successful design—transforming ideas into structured, buildable concepts.
      We work closely with clients to understand their needs, preferences, and vision. From site analysis and space optimization to layout design and project feasibility, our planning process ensures clarity, efficiency, and creativity from the very beginning.
      With a strong focus on functionality, aesthetics, and sustainability, we develop comprehensive plans that align with your goals and local building regulations—setting the stage for smooth execution and exceptional results.
      Let’s start building your vision—right from the blueprint."/>
        <div className='mt-24 mb-16'>
          <h1 className="flex justify-center text-center items-center text-2xl md:text-3xl mt-4 mb-4 font-roboto font-bold">Planning Services</h1>
          <div className='flex justify-center md:justify-between gap-5 p-5 flex-wrap align-middle items-center'>  
            <MaterialTailwindCard button="hidden" tittle="Concept Development" desc="We turn your ideas into a clear architectural vision through sketches, brainstorming, and early layout proposals" img={img1}/>
            <MaterialTailwindCard button="hidden" tittle="Space Optimization" desc="Every square meter matters. We design layouts that maximize space, comfort, and usability." img={img2}/>
            <MaterialTailwindCard button="hidden" tittle="Regulatory Planning" desc="We ensure your project aligns with local building codes and zoning regulations for smooth approvals." img={img3}/>
            <MaterialTailwindCard button="hidden" tittle="Site Analysis" desc="We assess the location, surroundings, and constraints to make smart planning decisions from the start." img={img4}/>          
        </div>
      </div>
      <Footer/>
    </div>
  )
}
